"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PersonOutput_1 = require("./PersonOutput");
var Output = (function () {
    function Output(subjectRetirementAge, partnerRetirementAge, includePartner, params) {
        this.year = [];
        this.deflationFactor = [];
        this.subjectOutput = new PersonOutput_1.PersonOutput(params, true);
        this.partnerOutput = new PersonOutput_1.PersonOutput(params, false);
        this.subjectRetirementAge = subjectRetirementAge;
        this.partnerRetirementAge = partnerRetirementAge;
        this.includePartner = includePartner;
    }
    Output.prototype.setYear = function (year) {
        this.year.push(year);
    };
    Output.prototype.addSubjectYearFrom = function (subject, subjectAccount, subjectEmployer) {
        this.subjectOutput.populateYear(this.year[this.year.length - 1], subject, subjectAccount, subjectEmployer);
    };
    Output.prototype.addPartnerYearFrom = function (partner, partnerAccount, partnerEmployer) {
        this.partnerOutput.populateYear(this.year[this.year.length - 1], partner, partnerAccount, partnerEmployer);
    };
    Output.prototype.addDeflatedData = function (totalYears, subject, subjectAccount, subjectEployer, partner, partnerAccount, partnerEmployer) {
        for (var yearCount = 1; yearCount <= totalYears; yearCount++) {
            this.deflationFactor.push(subjectAccount.getDeflationFactorInYear(yearCount));
        }
        this.subjectOutput.addDeflatedData(totalYears, subject, subjectAccount, subjectEployer);
        this.partnerOutput.addDeflatedData(totalYears, partner, partnerAccount, partnerEmployer);
        this.subjectOutput.removeWithdrawalFromActualDrawings(this.get_subjectRetirementAgeIndex(), subject.lumpSumWithdrawalAtRetirement);
        this.partnerOutput.removeWithdrawalFromActualDrawings(this.get_partnerRetirementAgeIndex(), partner.lumpSumWithdrawalAtRetirement);
    };
    Output.prototype.deflatedCombinedBalanceAtRetirement = function () {
        return this.deflatedCombinedBalanceAtIndex(this.get_subjectRetirementAgeIndex());
    };
    Output.prototype.deflatedCombinedBalanceAtIndex = function (index) {
        return this.subjectOutput.deflatedAssetsInYear[index] + (this.includePartner ? this.partnerOutput.deflatedAssetsInYear[index] : 0);
    };
    Output.prototype.deflatedCombinedIncomeAtRetirement = function () {
        return this.deflatedCombinedIncomeAtIndex(this.get_subjectRetirementAgeIndex());
    };
    Object.defineProperty(Output.prototype, "subjectRetirementAgeIndex", {
        get: function () {
            return this.subjectAgeToIndex(this.subjectRetirementAge);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Output.prototype, "partnerRetirementAgeIndex", {
        get: function () {
            return this.partnerAgeToIndex(this.partnerRetirementAge);
        },
        enumerable: true,
        configurable: true
    });
    Output.prototype.get_subjectRetirementAgeIndex = function () {
        return this.subjectAgeToIndex(this.subjectRetirementAge);
    };
    Output.prototype.get_partnerRetirementAgeIndex = function () {
        return this.partnerAgeToIndex(this.partnerRetirementAge);
    };
    Output.prototype.deflatedCombinedIncomeAtIndex = function (index) {
        var total = this.subjectOutput.deflatedActualDrawingsInYear[index] + this.subjectOutput.deflatedAgePension[index]
            + this.subjectOutput.deflatedOtherIncome[index] + this.subjectOutput.deflatedNetSalary[index]
            + (this.includePartner ? this.partnerOutput.deflatedActualDrawingsInYear[index]
                + this.partnerOutput.deflatedAgePension[index] + this.partnerOutput.deflatedOtherIncome[index]
                + this.partnerOutput.deflatedNetSalary[index] : 0);
        return total;
    };
    Output.prototype.deflatedCombinedIncomeAtSubjectAge = function (age) {
        return this.deflatedCombinedIncomeAtIndex(this.subjectAgeToIndex(age));
    };
    Output.prototype.subjectAgeToIndex = function (age) {
        return this.subjectOutput.age.indexOf(age);
    };
    Output.prototype.partnerAgeToIndex = function (age) {
        return this.partnerOutput.age.indexOf(age);
    };
    Output.prototype.indexToSubjectAge = function (index) {
        return index + this.subjectOutput.age[0];
    };
    Output.prototype.indexToPartnerAge = function (index) {
        return index + this.partnerOutput.age[0];
    };
    Object.defineProperty(Output.prototype, "lastIndex", {
        get: function () {
            return this.year.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Output.prototype.get_lastIndex = function () {
        return this.year.length - 1;
    };
    Output.prototype.indexOfFirstFailureToMeetTarget = function (combinedTarget, tolerance) {
        if (tolerance === void 0) { tolerance = 0; }
        var startIndex;
        startIndex = this.get_subjectRetirementAgeIndex();
        var index = startIndex;
        while (index < this.get_lastIndex() && this.deflatedCombinedIncomeAtIndex(index++) > combinedTarget * (1 - tolerance)) {
        }
        return index;
    };
    Output.prototype.subjectAgeOfFirstFailureToMeetTarget = function (combinedTarget, tolerance) {
        if (tolerance === void 0) { tolerance = 0; }
        return this.indexToSubjectAge(this.indexOfFirstFailureToMeetTarget(combinedTarget, tolerance));
    };
    return Output;
}());
exports.Output = Output;
//# sourceMappingURL=Output.js.map